<template>
  <div id="ending">
    <div class="bg"></div>
    <div class="wrap" :style="frameStyle" @click.capture="onClick">
      <div class="inner">
        <div class="txtWrap">
          <p>お疲れ様でした</p>
          <p>これで「かぐや様は告らせたい</p>
          <p>～天才たちとの恋愛頭脳GAME～」は</p>
          <p v-if="shijoFlag===true">全てクリアとなります</p>
          <p v-if="shijoFlag===false"><span>クリアとなります</span></p>
          <p>こんなゲームを</p>
          <p>最後までクリアするなんて…</p>
        </div>
        <div class="arrow" :style="arrowStyle"></div>
        <div class="img">
          <img v-if="shijoFlag===true" :src="`${publicPath}img/top/ending_kaguya.png`">
          <img v-if="shijoFlag===false" :src="`${publicPath}img/top/ending_ishigami.png`">
        </div>
        <div class="shijo">
          <div class="chara"><img :src="`${publicPath}img/top/ending_shijo01.png`"></div>
          <div class="text"><img :src="`${publicPath}img/top/ending_shijo02.png`"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _$ from 'jquery'

  export default {
    name: 'Ending',
    data() {
      return {
        publicPath: process.env.BASE_URL,
        frameStyle: {
          backgroundImage: 'url(./img/common/pink_frm01_684_t.png),url(./img/common/pink_frm01_684_b.png), url(./img/common/pink_frm01_l.png), url(./img/common/pink_frm01_r.png)'
        },
        arrowStyle: {
          backgroundImage: 'url(./img/common/pink_arw.png)'
        },

        timer_text: null,
        timer_start: null,
        timer_arrow: null,
        timer_img: null,
        timer_shijo: null,

        shijoFlag: false
      }
    },
    created() {
    },
    mounted() {
      let clearStateObj = this.$parent.$parent.storageData.clearState
      if(clearStateObj['shijo']){
        this.shijoFlag = true
      }

      _$('#ending .wrap').fadeIn(500)
      this.startTxt()
    },
    destroyed() {
      clearTimeout(this.timer_start)
      clearTimeout(this.timer_text)
      clearTimeout(this.timer_arrow)
      clearInterval(this.timer_img)
      clearInterval(this.timer_shijo)
    },
    methods: {
      startTxt(){
        this.clickFrag = false

        this.timer_start = setTimeout(function(){
          clearTimeout(this.timer_start)
          this.showText()
        }.bind(this), 800)
      },
      // typeAnim: function(){
      //   let txtsrc_array = this.txtsrc.replace(/<br>/g, ',<br>,').replace(/<span/g, ',<span').replace(/<\/span>/g, '</span>,')
      //   let array_woBR = txtsrc_array.split(',')
      //   let allText = ''

      //   for(let el of array_woBR){
      //     let joinText = null
      //     if(el.indexOf('<') === -1){
      //       joinText = el.split('').join()
      //     } else {
      //       joinText = el
      //     }
      //     allText += joinText
      //   }

      //   this.textArray = allText.split(',')

      //   let textArray_length = this.textArray.length
      //   let countNum = 0

      //   this.timer_text = setInterval(function(){
      //     this.textVal += this.textArray[countNum]
      //     countNum++
      //     if(countNum === textArray_length){
      //       clearInterval(this.timer_text)
      //       this.blinkArrow()
      //       this.clickFrag = true
      //     }
      //   }.bind(this), 120)
      // },
      showText() {
        let text_count = 0,
            opacityVal = 0,
            lineNum = 0

        this.timer_text = setInterval(function(){
          text_count++
          opacityVal += .2
          _$('#ending .txtWrap p').eq(lineNum).css({
            opacity: opacityVal
          })

          if(lineNum === 5 && opacityVal === 1){
            clearInterval(this.timer_text)
            this.blinkArrow()
            this.clickFrag = true
          } else if(text_count === 5){
            text_count = 0
            opacityVal = 0
            lineNum++
          }

        }.bind(this), 200)
      },
      showImg() {
        let img = _$('#ending .img'),
            wrap = _$('#ending .wrap'),
            _this = this

        img.fadeIn(1000, function(){
          _this.timer_img = setTimeout(function(){
            if(_this.shijoFlag){
              // 四条クリア
              wrap.fadeOut(500, function(){
                _this.$parent.endingFlag = false
              })
            } else {
              // 四条未クリア
              img.fadeOut(1000, function(){
                _this.showShijo()
              })
            }
          }, 1800)
        })
      },
      showShijo(){
        let shijoImg = _$('#ending .shijo .chara'),
            shijoTxt = _$('#ending .shijo .text'),
            wrap = _$('#ending .wrap'),
            shijo_count = 0,
            movVal = 0,
            _this = this

        _$('#ending .shijo').show()

        this.timer_shijo = setInterval(function(){
          shijo_count++

          switch(true){
            case shijo_count >= 1 && shijo_count <= 11:
            case shijo_count >= 21 && shijo_count <= 33:
              movVal += 5
              if(shijoTxt.is(':visible')){
                shijoTxt.hide()
              }
              break
            case shijo_count >= 12 && shijo_count <= 20:
              if(!shijoTxt.is(':visible')){
                shijoTxt.show()
              }
          }

          shijoImg.css({
            transform: 'translateX(' + movVal * -1 + 'vw)'
          })
          
          if(shijo_count === 35){
            clearInterval(_this.timer_shijo)
            wrap.fadeOut(500, function(){
              _this.$parent.endingFlag = false
            })
          }
        }, 500)
      },
      onClick: function(){
        if(this.clickFrag){
          clearTimeout(this.timer_arrow)
          this.clickFrag = false

          // 画像表示
          _$('#ending .txtWrap').hide()
          _$('#ending .arrow').hide()
          this.showImg()
        }
      },
      blinkArrow: function(){
        this.timer_arrow = setInterval(function(){
          _$('#ending .arrow').toggle()
        }.bind(this), 500)
      }
    }
  }
</script>

<style lang="scss" scoped>
  #ending {
    background: rgba(#000, 0);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;

    .bg {
      width: 100%;
      height: 100%;
      pointer-events: none;
    }

    .wrap {
      background-color: rgba(#000, .9);
      background-position: center top, center bottom, left top, right top;
      background-repeat: no-repeat, no-repeat, repeat-y, repeat-y;
      background-size: 100% auto, 100% auto, toVW(10) auto, toVW(10) auto;
      width: toVW(684);
      height: calc(100% - 8.8vw);
      padding: toVW(10);
      position: absolute;
      top: toVW(33);
      left: toVW(33);
      display: none;

      .inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }
    }

    .txtWrap {
      height: toVW(500);
      font-size: toVW(34);
      text-align: center;
      line-height: 2.35em;

      p {
        opacity: 0;
      }

      span {
        color: $COLOR_PINK01;
      }
    }

    .arrow {
      background-repeat: no-repeat;
      background-size: contain;
      width: toVW(28);
      height: toVW(21);
      position: absolute;
      bottom: toVW(48);
      right: toVW(45);
      display: none;
    }

    .img {
      background: #000;
      width: 100%;
      display: none;
    }

    .shijo {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      display: none;

      .chara {
        width: toVW(187);
        position: absolute;
        bottom: toVW(180);
        right: toVW(-187);
      }

      .text {
        width: toVW(94);
        position: absolute;
        bottom: toVW(360);
        right: toVW(125);
        display: none;
      }
    }
  }
</style>
